<template>
  <div class="user-field">
    <user-short
      :hide-default-avatar="true"
      :id="`user-short-${uuid}`"
      :user-id="selected"
      :length="length"
    ></user-short>
    <b-popover
      ref="popover"
      :target="`user-short-${uuid}`"
      placement="bottom"
      custom-class="user-editor-popover"
      triggers="click"
    >
      <user-editor
        :selected="selected"
        :team-id="teamId"
        :org-id="orgId"
        :placeholder="fieldName"
        @save="onSave"
        @cancel="hidePopover"
      ></user-editor>
    </b-popover>
  </div>
</template>

<script>
import UserEditor from '@/components/initiative/UserEditor'
import { BPopover } from 'bootstrap-vue'
import UserShort from './../UserShort'

let uuid = 0

export default {
  name: 'UserField',
  components: {
    BPopover,
    UserShort,
    UserEditor
  },
  props: ['selected', 'teamId', 'length', 'orgId', 'fieldName'],
  data() {
    ++uuid
    return {
      uuid: 'user-field-' + uuid.toString()
    }
  },
  methods: {
    onSave(userId) {
      this.$emit('change', userId)
    },
    hidePopover() {
      this.$refs.popover.$emit('close')
    },
    showPopover() {
      this.$refs.popover.$emit('open')
    },
    togglePopover() {
      if (this.$refs.popover.show) {
        this.hidePopover()
      } else {
        this.showPopover()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.user-editor-popover {
  border-radius: 16px;

  /deep/ .arrow {
    display: none;
  }
}
</style>

<style lang="scss">
@import '~@/styles/styleConfigurations';

.popover-gap-filler {
  content: ' ';
  position: absolute;
  left: 0;
  right: 0;
  height: 10px;
}

@include media-breakpoint-down(sm) {
  .user-editor-popover {
    position: fixed !important;
    left: 50% !important;
    top: 50% !important;
    transform: translate3d(-50%, -50%, 0) !important;
    min-width: 320px;
    box-shadow: 0px 10px 30px #9f9f9f !important;
  }
}
</style>
